import { useCallback, useEffect, useState } from 'react'
import { getPlatformChatOpenDimensions } from '@common/Chat/helpers'

export const usePlatformChatOpenDimensions = () => {
  const [dimensions, setDimensions] = useState(getPlatformChatOpenDimensions)

  const refresh = useCallback(() => {
    setDimensions(getPlatformChatOpenDimensions())
  }, [])

  useEffect(() => {
    refresh()
    window.addEventListener('resize', refresh)
    window.addEventListener('platform-chat-size-change', refresh)
    return () => {
      window.removeEventListener('resize', refresh)
      window.removeEventListener('platform-chat-size-change', refresh)
    }
  }, [refresh])

  return dimensions
}
